import React, { createContext, useContext, useRef, useState } from 'react';
import Loader from '../components/Loader/Loader';

const LoaderContext = createContext();

export const LoaderProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);
  const [userDetails, setUserDetails] = useState();
  const [activePlan, setActivePlan] = useState();
  const [device, setDevice] = useState("");
  const reportPdfRef = useRef();
  const containerRef = useRef();

  return (
    <LoaderContext.Provider value={{ loading, setLoading, userDetails, setUserDetails, activePlan, setActivePlan, device, setDevice, reportPdfRef,containerRef  }}>
      {children}
      {loading && <Loader />}
    </LoaderContext.Provider>
  );
};

export const useContextValue = () => useContext(LoaderContext);
